export const proxyImage = (url: string, width: number, height: number) => {
  if (!url) return `https://fakeimg.pl/${width}x${height}/cccccc/cccccc`

  const urlWithProxy = url.replace('assets/', 'assets/imgproxy/')
  return `${urlWithProxy}?width=${width}&height=${height}`
}
